<div class="give-instruction" (click)="viewInstructions(item)">
    <span>Add instructions</span>
</div>